export default function NotFound() {
    return (
      <div className="content">
        <div className="NotFound">
            <p><b>De opgevraagde pagina bestaat helaas niet.</b></p>
            <p>Mogelijk is de link die u gebruikt heeft verouderd. Wellicht is de informatie die u zoekt elders op de website terug te vinden.</p>
        </div>
      </div>
    );
  }   